<homi-navigation-bar
  [navItems]="navItems()"
  [user]="userFullName()"
  (logout)="logout()"
/>
<ion-router-outlet />
